<template>
    <v-container class="services">
        <v-layout class="services-bottom">
            <v-flex xs12 md6 class="services-bottom-block">
                <h3>Рассчитай ОСАГО<br>сразу в 15 страховых</h3>
                <v-flex class="services-bottom-block__item">
                    <img :src="'/svg/woman-technologist.svg'"/>
                    <img :src="'/svg/link.svg'"/>
                    <p>Сравните предложения в 15 страховых компаниях и оформите полис за 5 минут по лучшей цене. Наши клиенты экономят до 350 руб.</p>
                    <a
                        class="button next-button block"
                        :href="'/calc'"
                    >
                        Рассчитать ОСАГО
                    </a>
                </v-flex>
            </v-flex>
            <v-flex xs12 md6 class="services-bottom-block">
                <h3>Стань агентом<br>и зарабатывай!</h3>
                <v-flex class="services-bottom-block__item">
                    <img :src="'/svg/money-bag.svg'"/>
                    <img :src="'/svg/desktop-computer.svg'"/>
                    <p>Зарабатывай с каждой продажи ОСАГО до 35%.<br>Оформите 3 полиса и восстанавливайте КБМ бесплатно.</p>
                    <a
                        class="button next-button block"
                        :href="'https://b2b.getpolis.ru/login?registration'"
                    >
                        Зарегистрироваться
                    </a>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    export default {
        data: () => ({

        })
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/services/ServicesUnderList.vue